import { Typography } from "@mui/material";

export function SectionHeader({ children }: { children: string }) {
  return (
    <Typography
      variant="subtitle2"
      sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1, fontWeight: "bold", color: "text.secondary" }}
    >
      {children}
    </Typography>
  );
}
